// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"5e63a264e51ea9f9","2940":"d47c026191fd441b","4844":"9a07e84fac12664f","8356":"bf3b217b7955ee0e"}[chunkId] + ".css";
};